module.exports = __webpack_public_path__ + "img/culture-banner.152ae97f.jpg";